export enum NotificationType {
    ExportUsers = 1,
    ExportPrinters = 2,
    ExportDomains = 3,
    ExportUsersGroups = 4,
    ExportPrintersGroups = 5,
    ExportMachines = 6,
    ExportMachinesQueues = 7,
    ExportPolicies = 8,
    ExportReportPrintersWithLastAccounting = 9,
    ExportReportCardCodes = 10,
    QuotaPaymentPaid = 11,
    QuotaPaymentCancelled = 12,
    DeletedUser = 13,
    ExportReportSaveTonerEconomy = 14,
    ExportReportSaveTonerComparative = 15,
    DeletedPrinter = 16,
}
